import {
  normalizeLocaleKey,
  normalizeLocaleKeys,
} from '../v2/pages/organization/configurations/language/constants';

type LocaleOption = {
  key: string;
  label: string;
};

const FALLBACK_LOCALE_KEY = 'english';

export function buildAllowedLocaleKeysForV2(options: {
  defaultLanguage?: string | null;
  translationSupportLanguages?: string[] | null;
}): string[] {
  const normalizedDefault = normalizeLocaleKey(options.defaultLanguage) || FALLBACK_LOCALE_KEY;
  const normalizedSupport = normalizeLocaleKeys(options.translationSupportLanguages || []);

  const merged = [normalizedDefault, ...normalizedSupport].filter(
    (locale, index, arr) => arr.indexOf(locale) === index,
  );

  return merged.length > 0 ? merged : [FALLBACK_LOCALE_KEY];
}

export function filterLocaleOptionsByAllowedKeys(
  localeOptions: readonly LocaleOption[],
  allowedLocaleKeys?: string[] | null,
): LocaleOption[] {
  const normalizedAllowed = normalizeLocaleKeys(allowedLocaleKeys || []);
  if (normalizedAllowed.length === 0) {
    return [...localeOptions];
  }

  const allowedSet = new Set(normalizedAllowed);
  return localeOptions.filter((option) => {
    const normalizedKey = normalizeLocaleKey(option.key);
    return normalizedKey ? allowedSet.has(normalizedKey) : false;
  });
}
